<template>
    <b-modal id="modal-conf" size="xl" hide-header :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <template v-slot:default="{ hide }">
            <pdfx v-for=" i in numPages" ref="pdfCertidao" :page="i" :src="vpdf" style="width:100%" v-bind:key="i"></pdfx>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="lg" variant="danger" @click="devolveResposta('n')" class="mr-auto">Recusar</b-button>
            <b-button size="lg" variant="success" @click="devolveResposta('s')" >Aceitar</b-button>
        </template>
  </b-modal>
</template>
<script>
import pdfx from "vue-pdf";
import API from '@/services/api'

export default {
    components: {
        pdfx
    },
    methods: {
        devolveResposta(resposta){
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-conf');
        },
       
    },
    created() {
        API.get("/usuario/termo-aceite-site/resgata").then((res) => {
            let pdf = "data:application/pdf;base64," + encodeURI(res.data.pdf);

            // Cria a tarefa de carregamento e acessa a promessa com .promise
            let loadingTask = pdfx.createLoadingTask(pdf);

            // Use .promise para acessar a promessa do loadingTask
            loadingTask.promise.then((pdf) => {
                this.numPages = pdf.numPages;
            });

            this.vpdf = loadingTask;
        }).catch((error) => {
            console.error("Erro ao carregar o PDF:", error);
        });
    },
    data(){
        return{
            resposta: 's',
            vpdf:null,
            numPages:null,
        }
    },
}
</script>
<style scoped>

</style>
